import React from 'react';

function Mastercard(props) {
  return (
    <svg width="30px" height="18px" viewBox="0 0 30 18" {...props}>
      <g id="Billing" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Billing--Account-Payment-States"
          transform="translate(-69.000000, -1032.000000)"
          fillRule="nonzero"
        >
          <g id="Group-2" transform="translate(56.000000, 1013.000000)">
            <g id="mastercard_icon" transform="translate(12.000000, 17.000000)">
              <g id="mc_symbol" transform="translate(0.000000, 0.357143)">
                <g id="Group" opacity="0" fill="#FFFFFF">
                  <rect id="Rectangle" x="0" y="0" width="31.8521212" height="20.9758621" />
                </g>
                <rect
                  id="Rectangle"
                  fill="#FF5F00"
                  x="11.7260606"
                  y="3.65448276"
                  width="8.40242424"
                  height="13.6644828"
                />
                <path
                  d="M12.5915152,10.487931 C12.5894054,7.82189691 13.8185718,5.30295348 15.9248485,3.65689655 C12.3466158,0.856909051 7.20813026,1.26475144 4.12058131,4.59380306 C1.03303236,7.92285467 1.03303236,13.0554212 4.12058131,16.3844728 C7.20813026,19.7135244 12.3466158,20.1213668 15.9248485,17.3213793 C13.8179015,15.6747997 12.58866,13.1548122 12.5915152,10.487931 Z"
                  id="Path"
                  fill="#EB001B"
                />
                <path
                  d="M29.3077056,16.7018391 L29.3077056,15.7351724 L29.4981818,15.7351724 L29.4981818,15.5351724 L29.0448485,15.5351724 L29.0448485,15.7351724 L29.2238961,15.7351724 L29.2238961,16.7018391 L29.3077056,16.7018391 Z M30.1877056,16.7018391 L30.1877056,15.5351724 L30.0505628,15.5351724 L29.8905628,16.3685057 L29.7305628,15.5351724 L29.5934199,15.5351724 L29.5934199,16.7018391 L29.6924675,16.7018391 L29.6924675,15.8185057 L29.841039,16.5768391 L29.9438961,16.5768391 L30.0924675,15.8185057 L30.0924675,16.7018391 L30.1877056,16.7018391 Z"
                  id="Shape"
                  fill="#F79E1B"
                />
                <path
                  d="M30.0460606,10.487931 C30.0460606,13.8149539 28.1380414,16.8498811 25.1325467,18.3037675 C22.1270521,19.7576539 18.5516581,19.3752505 15.9248485,17.3189655 C18.0302061,15.6715111 19.259465,13.1529026 19.259465,10.4867241 C19.259465,7.82054567 18.0302061,5.30193715 15.9248485,3.65448276 C18.5516581,1.5981978 22.1270521,1.21579442 25.1325467,2.66968079 C28.1380414,4.12356716 30.0460606,7.15849439 30.0460606,10.4855172 L30.0460606,10.487931 Z"
                  id="Path"
                  fill="#F79E1B"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default Mastercard;
